import React from "react"


export default class FaqContent extends React.Component{

  state = {
    frontpageObject: null,
  }




  render(){
    
    
    return (
      <React.Fragment>
        
        <h1>gfd</h1>
      </React.Fragment>
    )
  }
}

